import clsx from "clsx";

import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";
import { gaClickAttrs } from "@/utils/tracking";

import styles from "./LocationFacet.module.css";

const ref = "location-facet";

interface LocationFacetProps extends Partial<CommonProps> {
  count: number | null;
  distance: number;
  onClick: () => void;
}

function useLocationFacet(props: LocationFacetProps) {
  const { id = createId(ref), distance } = props;
  const className = clsx(styles[ref], props.className);

  return {
    className,
    id,
    label: `Within ${distance} miles`,
  };
}

function LocationFacet(props: LocationFacetProps) {
  const { className, id, label } = useLocationFacet(props);
  const { count } = props;

  return (
    <div className={className} id={id}>
      <div
        className={styles.label}
        onClick={props.onClick}
        {...gaClickAttrs({
          eventGroup: "Filters",
          click: "location_click",
          clickTarget: label,
        })}
      >
        {label}
        {count && <span className={styles.count}>({count})</span>}
      </div>
    </div>
  );
}

export default LocationFacet;
export { LocationFacet, type LocationFacetProps };
